(() => {
'use strict';
if (customElements.get('studio-delivery')) return;
const allowed = ['peninsula', 'baleares', 'fr', 'pt', 'other'];
const interpolate = (text, values) => text.replace(/__([a-z]+)__/g, (_, key) => values[key] ?? '');
const formatDate = (value, compact = false) => new Intl.DateTimeFormat(document.documentElement.lang || 'es', compact ? {day:'numeric', month:'short', timeZone:'UTC'} : {weekday:'long', day:'numeric', month:'long', timeZone:'UTC'}).format(new Date(value+'T12:00:00Z'));
class StudioDelivery extends HTMLElement {
  connectedCallback() {
    this.labels = JSON.parse(this.querySelector('[data-delivery-labels]').textContent);
    this.select = this.querySelector('select');
    this.compact = this.dataset.compact === 'true';
    let saved; try { saved = sessionStorage.getItem('pw-delivery-destination'); } catch (_) {}
    const country = this.dataset.country, province = this.dataset.province;
    const initial = country === 'ES' ? (['GC','TF','CE','ML'].includes(province) ? 'other' : province === 'PM' ? 'baleares' : 'peninsula') : country === 'FR' ? 'fr' : country === 'PT' ? 'pt' : 'other';
    this.select.value = allowed.includes(saved) ? saved : initial;
    this.onChange = () => { try { sessionStorage.setItem('pw-delivery-destination', this.select.value); } catch (_) {} this.setZone(); this.querySelector('details')?.removeAttribute('open'); };
    this.select.addEventListener('change', this.onChange);
    this.productForm = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;
    this.onQuantity = event => { if (event.target.name === 'quantity') this.render(); };
    this.productForm?.addEventListener('input', this.onQuantity);
    this.productForm?.addEventListener('change', this.onQuantity);
    this.setZone();
    this.timer = setInterval(() => this.render(), 1000);
  }
  disconnectedCallback() { clearInterval(this.timer); this.select?.removeEventListener('change', this.onChange); this.productForm?.removeEventListener('input', this.onQuantity); this.productForm?.removeEventListener('change', this.onQuantity); }
  setZone() {
    document.documentElement.dataset.pwDeliveryZone = this.select.value;
    document.dispatchEvent(new CustomEvent('pw:delivery-zone', {detail:{zone:this.select.value}}));
    this.render();
  }
  isReady() {
    if (this.dataset.ready !== 'true') return false;
    if (!this.productForm || this.dataset.inventory === undefined) return true;
    const quantity = Number(this.productForm.elements.namedItem('quantity')?.value || 1);
    return Number.isFinite(quantity) && quantity > 0 && quantity <= Number(this.dataset.inventory);
  }
  setText(selector, text) { const el = this.querySelector(selector); if (el.textContent !== text) el.textContent = text; }
  render() {
    const labels = this.labels, zone = this.select.value;
    this.setText('.studio-delivery__transit', '');
    this.setText('.studio-delivery__countdown', '');
    if (zone === 'other') { this.setText('.studio-delivery__date', labels.unknown); return; }
    if (!this.isReady()) { this.setText('.studio-delivery__date', labels.stock); return; }
    if (zone === 'fr' || zone === 'pt') { this.setText('.studio-delivery__date', labels.international); return; }
    if (!window.PrinkDeliveryCalendar) return;
    const result = window.PrinkDeliveryCalendar.estimate(new Date(), zone === 'baleares' ? 3 : 1, (this.dataset.holidays || '').split(/[\s,;]+/).filter(Boolean));
    const arrival = formatDate(result.arrival, this.compact);
    this.setText('.studio-delivery__date', result.tomorrow ? labels.tomorrow+(this.compact ? '' : ' · '+arrival) : interpolate(labels.receive, {date:arrival}));
    if (zone === 'baleares') this.setText('.studio-delivery__transit', labels.baleares);
    if (result.open) {
      const seconds = result.secondsLeft;
      const time = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
      this.setText('.studio-delivery__countdown', this.compact ? interpolate(labels.order_compact,{time}) : interpolate(labels.order_before,{time:'18:45'})+'\n'+interpolate(labels.time_left,{time}));
    } else this.setText('.studio-delivery__countdown', interpolate(this.compact ? labels.dispatch_compact : labels.next_dispatch,{date:formatDate(result.dispatch, this.compact)}));
  }
}
customElements.define('studio-delivery', StudioDelivery);
})();
